import { ChangeLogVersion } from "Application/Models/ChangeLog";

export const CHANGELOG: ChangeLogVersion[] = [
    {
        buildLabel: "Build 2026.04.28",
        date: "April 2026",
        items: [{ description: "Session report PDFs now show the correct date for sessions saved during British Summer Time.", type: "fix" }],
    },
    {
        buildLabel: "Build 2026.04.22",
        date: "April 2026",
        items: [
            { description: 'New "What\'s New" panel shows the latest updates after login.', type: "feature" },
            { description: "Current build version now shown on the login page.", type: "feature" },
            { description: "Weekly rota is much faster when switching between weeks.", type: "improvement" },
            { description: "Mentors can now update sessions in slots where they're marked unavailable.", type: "fix" },
            { description: "Mentors land on the Weekly Rota after login instead of a blank page.", type: "fix" },
            { description: "Phone numbers starting with zero now save correctly.", type: "fix" },
            { description: '"View details" on Outreach and Enquiry student tabs now opens the correct student.', type: "fix" },
            { description: 'The "What\'s New" panel now appears only once per build, not on every login.', type: "fix" },
        ],
    },
    {
        buildLabel: "Build 2026.04.21",
        date: "April 2026",
        items: [
            { description: "Build label now displayed on the login page", type: "feature" },
            { description: "Fixed mentor navigation timeouts on weekly rota", type: "fix" },
        ],
    },
];
